import { cloneDeep } from 'lodash';

const state = {
  list: []
};

const getters = {
  list(state) {
    return state.list || [];
  },
  unread(state, getters, rootState, rootGetters) {
    return getters.list.filter((x) => x.userInfoId !== rootGetters['user/userInfoId'] && !x.readDate);
  }
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_MESSAGE(state, item) {
    const index = state.list.findIndex((x) => x.id === item.id);
    if (index >= 0) {
      this._vm.$set(state.list, index, cloneDeep(item));
    } else {
      state.list.push(cloneDeep(item));
    }
  },
  SET_READ(state, req) {
    const items = state.list.filter(x => req.ids.includes(x.id));
    for (var item of items) {
      item = Object.assign(item, { readDate: req.date });
    }
  }
};

const actions = {
  async getList({ commit }, designRequestId) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get(`messages/getList?designRequestId=${designRequestId}`)
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async add({ commit }, item) {
    return new Promise((resolve, reject) => {
      commit('SET_MESSAGE', item);
      resolve();
    });
  },
  async markRead({ commit }, ids) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post('messages/markRead', ids)
        .then((response) => {
          commit('SET_READ', { ids, date: response.data.date });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
